var map = {
	"./IMG_1493.jpeg": 7112,
	"./IMG_2132.jpeg": 9768,
	"./IMG_2451 copy 2.jpeg": 4719,
	"./bath12.1012f0a6.png": 5671,
	"./bath13.e3a10f13.jpg": 8485,
	"./bath3.2ae62124.JPG": 1369,
	"./bath4.7409bd09.JPG": 8743,
	"./bath5.33f16b5e.JPG": 4864,
	"./bath6.png": 7128,
	"./bath8.b5807d72.JPG": 8953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4112;